
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import {
  Lead, LeadStatus, PermissionCode, User,
} from '@/types';
import LeadTakeDialog from '@/components/LeadTakeDialog.vue';

@Component({
  components: {
    LeadTakeDialog,
  },
})
export default class LeadStatusAlert extends Vue {
  @Prop(Boolean) readonly loading!: boolean

  takeDialog = false

  get lead(): Lead {
    return this.$store.getters.currentLead;
  }

  get status(): LeadStatus {
    return this.lead.status;
  }

  get closed(): boolean {
    return this.lead && this.status === 'closed';
  }

  get open(): boolean {
    return this.lead && this.status === 'open';
  }

  get rejected(): boolean {
    return this.lead && this.status === 'rejected';
  }

  get user(): User {
    return this.$store.getters.currentUser;
  }

  get userPermissions(): PermissionCode[] {
    return this.$store.getters.currentUserPermissions;
  }

  get isSuperUser(): boolean {
    return this.user && this.user.isSuperUser;
  }

  get closedReason(): string | false {
    return this.lead
      && 'closedReason' in this.lead
      && 'closedReasonLong' in this.lead
      && this.lead.closedReason
      ? this.lead.closedReasonLong
      : false;
  }

  get rejectedNotes(): string | false {
    return this.lead
      && 'rejectedNotes' in this.lead
      && this.lead.rejectedNotes
      ? this.lead.rejectedNotes
      : false;
  }

  get alertType(): string {
    switch (this.status) {
      case 'new':
      case 'cancelled':
        return 'info';

      case 'resolved':
        return 'success';

      case 'closed':
      case 'rejected':
        return 'error';

      default:
        break;
    }

    return 'info';
  }

  get alertTitle(): string {
    switch (this.status) {
      case 'new':
        return !this.isChild
          ? '<strong>La lavorazione non è ancora iniziata</strong>'
          : `<strong>La lavorazione non è ancora iniziata</strong><br>Dopo aver cliccato sul tasto <strong>PRENDI IN CARICO</strong>,
            verranno mostrati i contatti del cliente e il <strong>modulo per il sopralluogo tecnico</strong>.`;

      case 'cancelled':
        return '<strong>La lavorazione è stata annullata</strong>';

      case 'resolved':
        return '<strong>Lavorazione completata con successo</strong>';

      case 'closed':
        return '<strong>La lavorazione è stata interrotta</strong> (chiusa).';

      case 'rejected':
        return '<strong>La lavorazione è stata respinta</strong>';

      default:
        break;
    }

    return 'info';
  }

  get isRequester(): boolean {
    return this.user && this.lead && this.user.id === this.lead.requesterId;
  }

  get isTakeVisible(): boolean {
    if (!this.lead || 'status' in this.lead === false
      || this.lead.status !== 'new') return false;

    if (this.isRequester && !this.lead.owners.find((u) => u.id === this.user.id)) return false;

    return this.hasPermission(`leads_${this.lead.type}.take`);
  }

  get isChild(): boolean {
    return ['installatore-figlia', 'elettrica-figlia', 'termica-figlia'].includes(this.lead.type);
  }

  hasPermission(codename: PermissionCode) {
    if (!this.user) return false;
    if (this.isSuperUser) return true;

    return this.userPermissions.includes(codename);
  }

  onTake() {
    console.log('LeadStatusAlert: onTake()'); // eslint-disable-line no-console

    this.takeDialog = true;
  }
}
